import React from "react";
import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { ShipFromQuery } from "view/ships/ShipDetails";
import { ChildProps } from "types/commons";

const ShipTonnageCertificatesTable = ({ tonnageCertificates }: { tonnageCertificates: ChildProps<ShipFromQuery, "tonnageCertificates"> }) => {
	return (
		<React.Fragment>
			<Table
				id="tonnage-certificates"
				onGetRowId={row => row.depth}
				content={tonnageCertificates.map(it => ({ ...it, id: undefined }))}
				columns={[ {
					id: "depth",
					title: intl.formatMessage({ id: "SHIP_TONNAGE_CERTIFICATES_DEPTH" }),
				}, {
					id: "tonnage",
					title: intl.formatMessage({ id: "SHIP_TONNAGE_CERTIFICATES_TONNAGE" }),
				} ]}
				disableFooter />
		</React.Fragment>
	);
};

export default ShipTonnageCertificatesTable;
